import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Eta from "../../components/general/Eta";
import Banner from "../../components/general/Banner";
import { useTranslation } from "react-i18next";
import NewsList from "./News";
import { useSelector, useDispatch } from "react-redux";
import { fetchContent } from "../../redux/slices/contentSlice";
import { fetchSeo } from "../../redux/slices/seoSlice";

const News = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const lang = useSelector((state) => state.lang.lang);
  const { dataContent } = useSelector((state) => state.content);
  const { dataSeo } = useSelector((state) => state.seo);
  const [seoData, setSeoData] = useState(null);

  useEffect(() => {
    dispatch(fetchContent());
    dispatch(fetchSeo());
  }, [dispatch]);

  useEffect(() => {
    const setSeoContent = async () => {
      if (dataSeo?.length > 0) {
        const newsData = dataSeo.find(
          (item) =>
            item.title[lang] === "Haberler" || item.title[lang] === "News"
        );
        if (newsData) {
          setSeoData(newsData);
          document.title = newsData.title[lang];
        }
      }
    };

    setSeoContent();
  }, [dataSeo, lang]);

  const bannerText = dataContent?.bannerText3?.[lang] || "";

  return (
    <Eta>
      {seoData && (
        <Helmet>
          <title>{seoData.title[lang]}</title>
          <meta name="description" content={seoData.description[lang]} />
          {seoData.keywords[lang] && (
            <meta name="keywords" content={seoData.keywords[lang]} />
          )}
          {seoData.canonical && (
            <link rel="canonical" href={seoData.canonical} />
          )}
          {seoData.author && <meta name="author" content={seoData.author} />}
        </Helmet>
      )}
      <Banner title={bannerText} />
      <NewsList />
    </Eta>
  );
};

export default News;
